import { useEffect } from 'react'
import { GrowthContent } from '@mc/api'
import { reportError } from '@mc/next-newrelic'
import { useStaticData } from '@mc/static-data-react'
import type { SubcategoryDynamicHeroValues } from 'libs/dynamic-hero'
import { trackViewedSubcategoryDynamicHeader } from 'libs/dynamic-hero'
import type { SubcategoryWithOutcome } from 'types/data'
import { HeroDesktop } from '../HeroDesktop'
import { HeroMobile } from '../HeroMobile'

type HeroProps = Parameters<typeof HeroMobile>[0]

export const SubcatPageHero = () => {
  const {
    subcatHeroCourses,
    subcatToOutcomes,
    subcatSlug,
    subcategorySavedDynamicHero,
  } = useStaticData<{
    subcatToOutcomes: SubcategoryWithOutcome
    subcatHeroCourses: GrowthContent[]
    subcatSlug: string
    subcategorySavedDynamicHero: SubcategoryDynamicHeroValues
  }>()

  const heading = subcategorySavedDynamicHero?.header || subcatToOutcomes.name
  const isDynamic = !!subcategorySavedDynamicHero?.header

  useEffect(() => {
    if (isDynamic) {
      trackViewedSubcategoryDynamicHeader({
        headline: heading,
        subcategorySlug: subcatSlug,
        isDynamicHero: isDynamic,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!subcatHeroCourses || subcatHeroCourses?.length < 2) {
    reportError(new Error('Missing subcatHeroCoursesMeta data'))
    return null
  }

  const [courseB, courseA] = subcatHeroCourses

  if (!(courseA && courseB)) {
    reportError(new Error('Missing featured course data for subcat hero'))
    return null
  }

  const props = {
    heading,
    courseA,
    courseB,
  } satisfies HeroProps

  return (
    <>
      <HeroMobile {...props} />
      <HeroDesktop {...props} />
    </>
  )
}
